import Emitter from "./Emitter";

export default class UpdateBalance extends Emitter {
    constructor(gb) {
        super(gb);
    }

    PRAGMATIC_PLAY_handler() {
        this.emitGame("updateBalance");
        this.emitGame({"type": "RefreshBalance"});
    }

    F1X2_handler() {
        this.emitGame("update-balance");
    }

    SLINGO_handler() {
        // not sure which one is correct ...
        this.emitGame({ event: "updateBalance" });
        this.emitGame({ event: "setBalance" });
    }

    GREENTUBE_handler() {
        this.emitGame("BALANCE:0");
    }

    IGT_handler() {
        this.emitGame(JSON.stringify({ message: "cust2rgsBalanceUpdated"}));
    }

    RELAX_handler() {
        this.emitGame({ rgMessage: "oprg_UpdateBalance"});
    }

    PNG_handler() {
        this.emitGame({ messageType: "request", request: "refreshBalance" });
    }

    THUNDER_handler(data) {
        this.emitGame({ eventid: "changebalance", data: { balance: data.payload.balance } });
    }

    EDICT_handler() {
        this.emitGame("updateBalance");
    }

    NSOFT_handler(balance) {
        this.settings.iframe.contentWindow.postMessage({ type: "balanceChanged", content: { balance: balance } }, this.settings.nsoftBaseUrl);
    }

    // GSYSB_handler(data) {
    //     this.emitGame({ event: "setBalance", payload: { balance: data.payload.balance } });
    // }

    GSYSP_handler(data) {
        this.emitGame({ event: "updateBalance"});
    }

    RAW_handler(data) {
        if (data && data.payload && data.payload.balance) {
            this.emitGame({ event: "setBalance", payload: { balance: data.payload.balance }});
        }
    }

    RGU_handler(data) {
        if (data && data.payload && data.payload.balance) {
            this.emitGame({ event: "setBalance", payload: { balance: data.payload.balance }});
        }
    }

    BGS_handler(data) {
        if (data && data.payload && data.payload.balance) {
            this.emitGame({ event: "setBalance", payload: { balance: data.payload.balance }});
        }
    }

    HB_handler(data) {
        if (data && data.payload && data.payload.balance) {
            this.emitGame({ event: "setBalance", payload: { balance: data.payload.balance }});
        }
    }

    WD_handler() {
        this.emitGame({ method: 'WGEAPI.updateBalance'});
    }

    STAKELOGIC2_handler(data) {
        if (data && data.payload) {
            this.emitGame({
                "event": "BALANCE_UPDATE",
                "payload": {balance: data.payload},
                "type": "REQUEST"
            });
        }
    }

    SPRIBE_handler(data) {
        if (data && data.data && data.data.value) {
            this.emitGame({
                cmd: 'ifc.set.balance', data: {value: data.data.value},
            })
        }
    }

    HI5_handler() {
        window.postMessage({cmd:"hi5_reload_balance"},"*");
    }

    // HKS_handler(payload) {
    //     if (payload && payload.eventData && payload.eventData.balance) {
    //         this.emitGame({actionType: "updateInGameBalance", eventData: {balance: payload.eventData.balance}});
    //     }
    // }

    SYN_handler() {
        this.emitGame({event: 'p2g.refreshBalance'});
    }

    KAJ_handler() {
        this.emitGame({'method': 'gel.balance.reload'});
    }

    YGG_handler() {
        this.emitGame({event: "balance/update"})
    }

    ORYX_handler(data) {
        if (data && data.balance) {
            let obj = { wpgaction: "updateBalance", param: { balance: data.balance }  };
            //in order to force balance update during game animations
            if (data.important && data.temp) {
                obj.param.important = data.important;
                obj.param.temp = data.temp;
            }
            this.emitGame(obj);
        } else if (data?.param?.balance) {
            this.emitGame({ wpgaction: "updateBalance", param: { balance: data.param.balance } });
        } else {
            this.emitGame({ wpgaction: "updateBalance" });
        }

    }

    HBN_handler() {
        this.emitGame({type: "refreshBalance"})
    }

    SPN_handler() {
        this.emitGame({type: "balanceRefresh"})
    }

    ENDOR_handler(data){
        if(data && data.payload) {
            this.emitGame({messageId: "setBalance", balance: {"balance": data.payload}});
        } else {
            this.emitGame({messageId: "updateBalance"});
        }
    }

    HABANERO2_handler(){
        this.emitGame({type: "refreshBalance"});
    }

    PUSH_handler() {
        this.emitGame({
            method: 'balanceTopUp'
        })
    }

    EVOLUTION_handler(data) {
        if (this.gb.evolutionSource) {
            if (data && data.payload) {
                this.gb.evolutionSource.postMessage({
                    command: "EVO:REFRESH_BALANCE",
                    expectedBalance: data.payload
                });
            } else {
                this.gb.evolutionSource.postMessage({
                    command: "EVO:REFRESH_BALANCE"
                });
            }
        }
    }

    _default(data) {
        if (data) {
            this.emitGame({ wpgaction: 'updateBalance', param: { balance: data } });
        } else {
            this.emitGame({ wpgaction: 'updateBalance'});
        }
    }

}
